/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SelettivaAddAnswerIrideDto } from '../../models/selettiva-add-answer-iride-dto';
import { SingleResponseAnswerIridePostDto } from '../../models/single-response-answer-iride-post-dto';

export interface ApiWsBridgeAlertcallAnswerPost$Params {
    /**
     * application/json
     */
    body: SelettivaAddAnswerIrideDto;
}

export function apiWsBridgeAlertcallAnswerPost(
    http: HttpClient,
    rootUrl: string,
    params: ApiWsBridgeAlertcallAnswerPost$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<SingleResponseAnswerIridePostDto>> {
    const rb = new RequestBuilder(rootUrl, apiWsBridgeAlertcallAnswerPost.PATH, 'post');
    if (params) {
        rb.body(params.body, 'Answer to add');
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<SingleResponseAnswerIridePostDto>;
        }),
    );
}

apiWsBridgeAlertcallAnswerPost.PATH = '/api/ws-bridge/alertcall/answer';
